import { useSnackbar } from 'notistack';

import { axios } from 'lib';
import { useMutation } from 'react-query';

const removeRemoveFile = async ({ directID, tcID = null, cgId = null, fileId }) => {
  let url = `/api/directs/${directID}/files/${fileId}`;
  if (tcID) {
    url = `/api/directs/${directID}/suppliers/${tcID}/files/${fileId}`;
  }

  if (cgId) {
    url = `/api/directs/${directID}/consortium_groups/${cgId}/files/${fileId}`;
  }

  axios.delete(url);
}
  

export const useRemoveFile = (onFileRemoval) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: removeRemoveFile,
    onSuccess: () => {
      enqueueSnackbar('The file was succesfully deleted', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      onFileRemoval();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
